import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { User } from '@app/core/models/user.model';
import { ProfileManagerService } from '@app/custom-shared/services/profile-manager.service';
import { LocalService } from '@app/shared/services/local.service';

@Component({
  selector: 'app-semaphore-card',
  templateUrl: './semaphore-card.component.html',
  styleUrls: ['./semaphore-card.component.scss']
})
export class SemaphoreCardComponent implements OnInit {

  @Output() onOpenFundOperation = new EventEmitter<any>();

  @Input()
  semaphoreTitles = [];

  @Input()
  dataAction = { data: [], status: [] };

  @Input()
  enable = false;

  semaphoreBody = [
    {
      semaphoreType: 'semaphore-red d-flex',
      icon: 'icon-x icon-24 semaphore-icon',
    },
    {
      semaphoreType: 'semaphore-yellow d-flex',
      icon: 'icon-pause icon-24 semaphore-icon',
    },
    {
      semaphoreType: 'semaphore-green d-flex',
      icon: 'icon-checkmark icon-24 semaphore-icon',
    }
  ];

  constructor(
    private profileService: ProfileManagerService,
    private secureStorage:LocalService
  ) {

  }

  ngOnInit() {
  }

  amount(status: string) {
    if (this.dataAction.data) {
      return this.dataAction.data.filter(
        data => data.status == status
      ).length;
    }
  }

  isButtonsActive() {
    if (!this.profileService.isMasterBO() && !this.profileService.isOperatorBO()) {
      
      if (this.secureStorage.getJsonValue('portfolioCode') != null) {
        if (JSON.parse(this.secureStorage.getJsonValue('portfolioCode')).portfolioCode != "" && JSON.parse(this.secureStorage.getJsonValue('portfolioCode')).portfolioCode != null && JSON.parse(this.secureStorage.getJsonValue('portfolioCode')).portfolioCode != undefined) {

          return true
        }
      } else {
        return false
      }
    } else {
      return true
    }
  }

  openPage(param?: any) {
    if (this.isButtonsActive()) {
      this.onOpenFundOperation.emit(param);
    }
  }

}
